import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTheme } from '../../contexts/ThemeContext';
import { CloseModalLightIcon, CloseModalDarkIcon, SearchIcon } from '../../assets/svg';
import useDebounce from '../../hooks/useDebounce';
import './CustomModal.scss';

interface ICustomModal {
  show: boolean;
  onHide?: () => void;
  title?: string;
  body: JSX.Element;
  className?: string;
  close?: boolean;
  size?: 'sm' | 'lg' | 'xl';
  backdrop?: 'static' | true;
  closeIcon?: any;
  isSearch?: boolean;
  searchText?: string;
}

const CustomModal: React.FC<ICustomModal> = ({
    size,
    show,
    onHide,
    title,
    body,
    className,
    close,
    backdrop,
    closeIcon,
    isSearch,
  }) => {
  const { darkTheme } = useTheme();
  const [searchText, setSearchText] = useState<string>('');

  const debouncedFn = useDebounce((newValue: string) => {

  }, 800);

  const handleSearchOnChange = (e: any) => {
    const { value } = e.target;
    setSearchText(value);
    debouncedFn(value);
  };
  return (
    <Modal
      size={size}
      show={show}
      onHide={onHide}
      centered
      className={`generic-modal ${className}`}
      backdrop={backdrop}
    >
      <Modal.Header className="d-flex w-100 justify-content-between" closeButton={close}>
        <Modal.Title>{title}</Modal.Title>
        {
          isSearch && (
            <div className="search-input-main">
              <div className="search-btn">
                <SearchIcon color="#1C1C1C66" />
              </div>
              <input
                type="text"
                name="search"
                placeholder="Search by Blockchain & Network"
                className="search-input"
                value={searchText}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSearchOnChange(e)}
              />
            </div>          )
        }
        {close && (
          <div onClick={onHide} className="close-icon">
            {closeIcon ? closeIcon : darkTheme ? <CloseModalDarkIcon /> : <CloseModalLightIcon />}
          </div>
        )}
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
    </Modal>
  );
};

export default CustomModal;
